import { GET_FOOTER, GET_FOOTER_LOADING } from "./constants";

const initialState = {
  loading: false,
  footer: null,
};

export default function footer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_FOOTER_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_FOOTER:
      return {
        ...state,
        footer: payload.data,
        loading: false,
      };

    default:
      return state;
  }
}
